import { AlertTriangle } from "lucide-react";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8 text-center min-h-[200px]">
      <AlertTriangle className="h-10 w-10 text-destructive" />
      <div className="space-y-1">
        <h3 className="text-lg font-semibold text-foreground">Something went wrong</h3>
        {import.meta.env.DEV && (
          <pre className="mt-2 max-w-md text-xs text-destructive bg-destructive/10 rounded p-2 overflow-auto text-left">
            {error.message}
          </pre>
        )}
      </div>
      <button
        onClick={resetErrorBoundary}
        className="px-4 py-2 text-sm font-medium rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
      >
        Try Again
      </button>
    </div>
  );
}
